import { render, staticRenderFns } from "./s-sbj-sub-input.vue?vue&type=template&id=1f601d6c&"
import script from "./s-sbj-sub-input.vue?vue&type=script&lang=js&"
export * from "./s-sbj-sub-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports